/**
 * Auto-generated file. Do not edit.
 * for qa
 */

export const RECAPTCHA_KEY = '6LeSiKgkAAAAAFY9MMr2ElEYJtQaUQAe95NH-BpS';
export const PUB_API_HOST = 'aibolit-qa2.epm-aimd.projects.epam.com';
